export default __webpack_public_path__ + "static/media/explain_top.b8cf8231.png";